
export class AudioContextManager {
    private interactionListenersBound = false;

    constructor(
        private readonly context: AudioContext
    ) {
    }

    public async tryResume(): Promise<void> {
        const state = this.context.state as string;
        if (state === 'running') return;

        try {
            await new Promise(resolve => setTimeout(resolve, 100));
            await this.context.resume();

            if (state !== 'running') {
                await this.context.resume();
            }

            if (state === 'running') {
                this.removeUserInteractionListeners();
                return;
            }

            this.addUserInteractionListeners();
        } catch (e) {
            console.warn('AudioContext resume failed:', e);
            this.addUserInteractionListeners();
        }
    }

    private addUserInteractionListeners(): void {
        if (this.interactionListenersBound) return;

        window.addEventListener('click', this.tryResumeBound);
        window.addEventListener('touchstart', this.tryResumeBound);
        this.interactionListenersBound = true;
    }

    private removeUserInteractionListeners(): void {
        if (!this.interactionListenersBound) return;

        window.removeEventListener('click', this.tryResumeBound);
        window.removeEventListener('touchstart', this.tryResumeBound);
        this.interactionListenersBound = false;
    }

    private tryResumeBound = this.tryResume.bind(this);
}